import { render, staticRenderFns } from "./detailClaimsRecord.vue?vue&type=template&id=0db25c2d&scoped=true&"
import script from "./detailClaimsRecord.vue?vue&type=script&lang=js&"
export * from "./detailClaimsRecord.vue?vue&type=script&lang=js&"
import style0 from "./detailClaimsRecord.vue?vue&type=style&index=0&id=0db25c2d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db25c2d",
  null
  
)

export default component.exports